<div class="input-container">
  <label
    *ngIf="label"
    [attr.for]="name"
    class="form-label d-flex align-items-center"
  >
    {{ label }}
    <sup *ngIf="isRequired && !hideRequiredStar" class="text-danger">*</sup>
    <i-feather
      *ngIf="helpText"
      name="Info"
      [attr.title]="helpText"
      class="help-icon"
    ></i-feather>
  </label>

  <div class="input-group">
    <input
      [attr.type]="type"
      [name]="name"
      [attr.id]="name"
      [(ngModel)]="value"
      (ngModelChange)="handleChange($event)"
      (blur)="handleBlur()"
      (focus)="markAsTouched()"
      [class.is-invalid]="showError"
      [ngClass]="classes"
      [autocomplete]="autocomplete"
      [disabled]="disabled"
      [placeholder]="placeholder ? placeholder : ''"
      [attr.tabindex]="tabindex"
      [attr.maxlength]="maxLength"
      [appMaxLengthNumber]="maxLengthNumber"
      class="form-control"
      (keydown)="preventInvalidKey($event)"
    />
    <div
      *ngIf="helpTextRight"
      class="tooltip-wrapper position-relative d-flex justify-content-center align-items-center"
    >
      <i-feather
        name="Info"
        [attr.title]="helpTextRight"
        class="help-icon ms-2 align-self-center"
        (click)="toggleTooltip()"
        (mouseleave)="hideTooltip()"
      ></i-feather>

      <p class="tooltip-text position-absolute" *ngIf="showToolTipText">
        {{ helpTextRight }}
      </p>
    </div>

    <div *ngIf="withRightIcon" class="input-group-append">
      <span class="input-group-text" [class.icon-pointer]="iconPointer">
        <ng-content select="[rightIcon]"></ng-content>
      </span>
    </div>
    <span *ngIf="fixedText" class="fixed-text">{{ fixedText }}</span>
    <ng-content select="[body]"></ng-content>
  </div>

  <p *ngIf="showCounter" class="text-muted small mt-1 counter">
    {{ value.length || 0 }} / {{ maxLength }}
  </p>

  <p
    *ngIf="description"
    [hidden]="formControl.touched && !formControl.valid"
    class="text-muted"
  >
    <small>{{ description }}</small>
  </p>

  <p [hidden]="!showError" class="text-danger">
    <small>{{ errorMessage }}</small>
  </p>
</div>
